import type { GrayscalePalette } from './types';

export const asciiPalette: GrayscalePalette = {
  id: 'ascii',
  name: 'ASCII',
  type: 'grayscale',
  characters: ['@', '#', '%', '*', '+', '=', '-', ':', '.', ' '],
};
